import React from "react";
import { Layers, StickyNote } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useTranslation } from "@/context/LanguageContext";

const STATUS_COLOR = { new: "hsl(215 12% 60%)", review: "hsl(38 92% 62%)", understood: "hsl(152 52% 46%)" };

export const GlossaryCard = ({ item, onOpen }) => {
    const { t, lang } = useTranslation();
    const date = item.created_at ? new Date(item.created_at).toLocaleDateString(lang) : "";
    const status = item.status || "new";
    return (
        <button
            data-testid="glossary-item"
            onClick={() => onOpen(item)}
            className="group flex w-full flex-col rounded-2xl border border-border bg-surface-1 p-4 text-left transition-all hover:-translate-y-0.5 hover:border-[hsl(var(--primary))]/40 hover:bg-surface-2"
        >
            <div className="flex items-start justify-between gap-2">
                <h3 className="min-w-0 flex-1 truncate font-sans-display text-sm font-semibold text-t1">{item.term}</h3>
                <span
                    className="mt-1.5 h-2 w-2 shrink-0 rounded-full"
                    style={{ background: STATUS_COLOR[status] || STATUS_COLOR.new }}
                    title={t(`glossary.status.${status}`)}
                    data-testid="glossary-item-status-dot"
                />
            </div>
            <p className="mt-1.5 line-clamp-2 min-h-[2.5rem] text-sm text-t3">{item.definition || "—"}</p>
            <div className="mt-3 flex flex-wrap items-center gap-2 text-t4">
                {item.domain && item.domain !== "general" && (
                    <Badge variant="secondary" className="bg-surface-3 text-[10px] uppercase">{t(`glossary.domain.${item.domain}`)}</Badge>
                )}
                <span className="max-w-[150px] truncate mono-label">{item.document_title}</span>
                {item.revisits > 0 && <span className="mono-label">· {t("glossary.revisitsLabel", { n: item.revisits })}</span>}
            </div>
            <div className="mt-2 flex items-center justify-between text-[11px] text-t4">
                <span className="mono-label">{t("glossary.savedOn", { date })}</span>
                <span className="flex items-center gap-2">
                    {item.note && <StickyNote className="h-3.5 w-3.5 text-[hsl(var(--primary))]" />}
                    {item.in_flashcards && <Layers className="h-3.5 w-3.5 text-[hsl(var(--primary))]" />}
                </span>
            </div>
        </button>
    );
};
